module.exports = __webpack_public_path__ + "assets/img/22_1232_big.228629ea.jpg";